import axiosInstance from "../axios";

export const getParts = (orderId) => {
  return axiosInstance.get(`/ops/order_parts`, {
    params: { id: orderId },
  });
};

export const getPackages = (orderId) => {
  return axiosInstance.get(`/ops/order_packages`, {
    params: { id: orderId },
  });
};

export const packParts = (orderId, partIds) => {
  return axiosInstance.put(
    `/ops/pack_parts`,
    {
      part_ids: partIds,
    },
    {
      params: { id: orderId },
    }
  );
};

export const deletePackages = (orderId, packageIds) => {
  return axiosInstance.post(
    `/ops/delete_packages`,
    {
      package_ids: packageIds,
    },
    {
      params: { id: orderId },
    }
  );
};

export const fetchOrders = () => {
  return axiosInstance.get(`/ops/orders`);
};

export const movePackages = (orderId, packageIds) => {
  return axiosInstance.put(`/ops/load_packages`, {
    id: orderId,
    package_ids: packageIds,
  });
};

export const unmovePackages = (orderId, packageIds) => {
  return axiosInstance.put(`/ops/unload_packages`, {
    id: orderId,
    package_ids: packageIds,
  });
};

export const dispatchPackages = (orderId, shipmentId) => {
  return axiosInstance.put(`/ops/dispatch_packages`, {
    id: orderId,
    shipment_id: shipmentId,
  });
};

export const deliverPackages = (orderId, packageIds) => {
  return axiosInstance.put(`/ops/deliver_packages`, {
    id: orderId,
    package_ids: packageIds,
  });
};
